/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Match format (number of games)
 * @export
 */
export const MatchFormat = {
    SINGLE_GAME: 'SINGLE_GAME',
    BEST_OF_3: 'BEST_OF_3',
    BEST_OF_5: 'BEST_OF_5',
    BEST_OF_7: 'BEST_OF_7',
    FIRST_TO_X: 'FIRST_TO_X'
} as const;
export type MatchFormat = typeof MatchFormat[keyof typeof MatchFormat];


export function instanceOfMatchFormat(value: any): boolean {
    for (const key in MatchFormat) {
        if (Object.prototype.hasOwnProperty.call(MatchFormat, key)) {
            if (MatchFormat[key as keyof typeof MatchFormat] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchFormatFromJSON(json: any): MatchFormat {
    return MatchFormatFromJSONTyped(json, false);
}

export function MatchFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchFormat {
    return json as MatchFormat;
}

export function MatchFormatToJSON(value?: MatchFormat | null): any {
    return value as any;
}

export function MatchFormatToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchFormat {
    return value as MatchFormat;
}

